"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtonsContainer = exports.Footer = exports.ScrollYBox = exports.StepContainer = exports.Header = exports.WizardContainer = void 0;

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _designTokens = require("@decisiv/design-tokens");

var _polished = require("polished");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styleModifiers = require("../../utils/styleModifiers");

var _Flex = _interopRequireDefault(require("../Flex"));

var _components = require("../Modal/components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var FOOTER_HEIGHT = {
  DEFAULT: (0, _polished.rem)(_designTokens.spacing.base * 6.2),
  TWO_BUTTONS: (0, _polished.rem)(_designTokens.spacing.base * 13.5),
  THREE_BUTTONS: (0, _polished.rem)(_designTokens.spacing.base * 19)
}; // Define styled components

var WizardContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center'
}).withConfig({
  displayName: "styles__WizardContainer",
  componentId: "sc-5745v5-0"
})(["width:100%;height:100%;overflow-y:auto;"]);
exports.WizardContainer = WizardContainer;
var Header = (0, _styledComponents.default)(_Flex.default).attrs({
  flex: 1,
  padding: 3,
  paddingBottom: 2,
  flexDirection: 'column',
  justifyContent: 'center'
}).withConfig({
  displayName: "styles__Header",
  componentId: "sc-5745v5-1"
})(["width:100%;background-color:", ";row-gap:", ";text-align:center;border-bottom:1px solid ", ";"], (0, _polished.toColorString)(_designTokens.color.base.fullMoon), (0, _polished.rem)(_designTokens.spacing.base * 2), (0, _polished.toColorString)(_designTokens.color.opacity.charcoal15));
exports.Header = Header;
var StepContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  flex: 1,
  padding: 3,
  flexDirection: 'column'
}).withConfig({
  displayName: "styles__StepContainer",
  componentId: "sc-5745v5-2"
})(["width:100%;"]);
exports.StepContainer = StepContainer;
var ScrollYBox = (0, _styledComponents.default)(_components.ScrollYBox).withConfig({
  displayName: "styles__ScrollYBox",
  componentId: "sc-5745v5-3"
})(["max-height:calc(100vh - ", ");", ";"], (0, _polished.rem)(_designTokens.spacing.base * 14.2), (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["position:relative;max-height:unset;overflow-y:unset;"]))); // this is not styled as mobile first because the button itself isnt yet

exports.ScrollYBox = ScrollYBox;
var Footer = (0, _styledComponents.default)(_components.Footer).withConfig({
  displayName: "styles__Footer",
  componentId: "sc-5745v5-4"
})(["width:100%;height:", ";flex-direction:row-reverse;justify-content:space-between;", ";"], FOOTER_HEIGHT.DEFAULT, (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["height:auto;position:relative;max-height:", ";flex-direction:column;align-items:flex-start;button{width:100%;height:", ";font-size:", ";}"], FOOTER_HEIGHT.THREE_BUTTONS, (0, _polished.rem)(_designTokens.spacing.base * 5), (0, _polished.rem)(_designTokens.typography.size.alias.extraLarge))));
exports.Footer = Footer;
var ActionButtonsContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  flex: 1,
  justifyContent: 'end'
}).withConfig({
  displayName: "styles__ActionButtonsContainer",
  componentId: "sc-5745v5-5"
})(["width:100%;flex-direction:column;margin-bottom:", ";row-gap:", ";", ";", ";"], (0, _polished.rem)(_designTokens.spacing.base * 0.5), (0, _polished.rem)(_designTokens.spacing.base * 0.5), (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["align-items:flex-start;"])), (0, _styleModifiers.when)('size', _breakpointObserver.sizes.LG, (0, _styledComponents.css)(["flex-direction:row-reverse;column-gap:", ";margin-bottom:0;"], (0, _polished.rem)(_designTokens.spacing.base * 0.5))));
exports.ActionButtonsContainer = ActionButtonsContainer;